import React, { useEffect, useRef, useContext } from "react";
import DropdownItem from "./DropdownItem";
import { socket } from "../../services/socket";
import { AuthContext } from "../../contexts/AuthContext";

export default function DropdownList({ display, setDisplay, notifications }) {
  const boxDropdownList = useRef(null);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        boxDropdownList.current &&
        !boxDropdownList.current.contains(event.target)
      ) {
        setDisplay(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        ref={boxDropdownList}
        className={`dropdown-menu dropdown-menu-rg dropdown-menu-end ${
          display
            ? "show affiche-dropdown-droit animate__animated animate__backInRight animate__repeat-1"
            : ""
        }`}
      >
        <div className="dropdown-head">
          <div className="title">
            <h4>Notifications</h4>
          </div>
          {notifications && notifications.some((n) => !n.read) && (
            <button
              className="btn btn-sm btn-light"
              onClick={() => {
                socket.emit("mark_all_notifications_read", user.userId);
              }}
            >
              Tout marquer lu
            </button>
          )}
        </div>
        <div className="dropdown-gap">
          <ul className="tyn-media-list gap gap-3">
            {!notifications || notifications.length === 0 ? (
              <h3 className="text-warning text-center">
                Vous n'avez aucune notification pour l'instant!
              </h3>
            ) : (
              notifications.map((notif) => (
                <DropdownItem key={notif._id} notification={notif} />
              ))
            )}
          </ul>
        </div>
      </div>
    </>
  );
}
